"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactAspectRatio = require("react-aspect-ratio");

require("lazysizes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Img = ({
  alt,
  base64,
  classname,
  onError,
  onLoad,
  placeholder,
  placeholderBase64,
  ratio = 1,
  src,
  srcset
}) => {
  const [error, setError] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const img = new Image();

    img.onload = () => {
      if (!onLoad) {
        return;
      }

      onLoad();
    };

    img.onerror = () => {
      if (!onError) {
        return;
      }

      setError(true);
      onError();
    };

    if (src) {
      img.src = src;
    } else {
      img.srcset = srcset;
    }
  }, []);

  if (error) {
    src = placeholder;
    srcset = null;
    base64 = placeholderBase64;
  }

  const imgProps = {
    alt
  };

  if (base64) {
    imgProps.src = base64;
  }

  if (srcset) {
    imgProps["data-srcset"] = srcset;
  } else {
    imgProps["data-src"] = src;
  }

  return _react.default.createElement(_reactAspectRatio.AspectRatio, {
    ratio: ratio
  }, _react.default.createElement("img", _extends({}, imgProps, {
    className: `lazyload blur-up ${classname}`
  })));
};

var _default = Img;
exports.default = _default;